// Angular
import { Component, Inject, OnDestroy } from '@angular/core';

// Libraries
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

// Models
import { AppCleanup } from '../../models';
import { SnackbarClassType } from '../../services';

@Component({
	selector: 'custom-snackbar',
	templateUrl: './custom-snackbar.component.html',
	styleUrl: './custom-snackbar.component.scss',
})
export class CustomSnackbarComponent extends AppCleanup implements OnDestroy {
	maxLength: number = 120;
	class: string = SnackbarClassType.INFO;

	constructor(
		private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: { message: string; panelClass: string; icon: string }
	) {
		super();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	close() {
		this.snackBarRef.dismiss();
	}
}
